import { gql } from "@apollo/client";

const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String) {
    login(email: $email, password: $password) {
      name
      id
      designation {
        name
        paneltype
      }
      mainSuperAdminId
      accessToken
      refreshToken
      username
      number
      picture
      pseudonym
    }
  }
`;

export default LOGIN_MUTATION;
